<template>
  <div class="instrument-index">
    <nav>
      <TopNav />
    </nav>
    <div class="page1">
<!--      <img class="mask-bg" src="../../assets/image/product.jpg"/>-->
    </div>
    <Footer/>
  </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "InstrumentIndex",
  components: {Footer, TopNav}
}
</script>
<style lang="less"  scoped>
.instrument-index {
  height: 100%;
  font-size: 16px;
  .page1 {
    height: 100%;
    position: relative;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      position: absolute;
      object-fit: fill;
      top: 0;
      left: 0;
      z-index: -1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/InstrumentIndex.vue